/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/

export {
  UnifiedSelectionContextProvider,
  useUnifiedSelectionContext,
} from "./unified-selection-react/UnifiedSelectionContext.js";
